export default "__VITE_ASSET__BaqyiaIe__"